<template>
    <div>
		<div class="formBox" v-if="formDatas" v-loading="listLoading">
			<el-form 
				:model="formDatas"					
				ref="formDatas"
				label-position="top"
				class="MT10">
				<el-form-item prop="canConsign">
					<el-card header="托售开关: ">						
						<el-radio-group v-model="formDatas.canConsign" @change="canAction()">
							<el-radio :label="1">开启</el-radio>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>
						<div class="color-danger MT10">
							说明：
							<div>1、开启后符合托售前置条件的订单会在订单详情页显示平台托售按钮</div>
							<div>2、关闭后已经处于托售中的订单会正常进行托售</div>
						</div>
					</el-card>					
				</el-form-item>
				<el-form-item prop="premium">
					<el-card header="托售手续费: ">
						<el-input-number v-model="formDatas.premium" @change="handleChange" :min="0" :max="10" label="请输入托售手续费" controls-position="right" :precision="2"></el-input-number> %
						<div class="color-danger">
							说明：
							<div>1、托售手续费是托售成功后收取到秀动账户的费用，从托售订单金额中扣除</div>
							<div>2、可设置范围为订单金额的0%-10%</div>
						</div>
					</el-card>					
				</el-form-item>
			</el-form>
		</div>
       
		
    </div>
</template>
<script>


export default {
	components: {  },
    data() {
        return {
            formDatas:{},  
            listLoading: true,
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        //获取列表
        getData() {
            this.listLoading = true;
            this.$request({
                url: "/consign/getInfo",
                method: "POST",
                
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.formDatas = result;
                       
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        canAction(){
			
			this.listLoading = true;
			this.$request({
			    url: "/consign/setCanConsign",
			    method: "POST",
			    params:{
					can:this.formDatas.canConsign,
					
				}
			})
			    .then((res) => {
			        const { state, msg } = res.data;
			        if (state == 1 ) {
			            this.$message.success("操作成功");
			            this.getData();
			        } else {
			            this.$message.error(msg || "请求失败");
			        }
			    })
			    .catch(() => {
			        this.$message.error("请求错误");
			    })
			    .finally(() => {
			        this.listLoading = false;
			    });
		},
		handleChange(){
			
			this.listLoading = true;
			this.$request({
			    url: "/consign/setPremium",
			    method: "POST",
			    params:{
					premium:this.formDatas.premium,
					
				}
			})
			    .then((res) => {
			        const { state, msg } = res.data;
			        if (state == 1 ) {
			            this.$message.success("操作成功");
			            this.getData();
			        } else {
			            this.$message.error(msg || "请求失败");
			        }
			    })
			    .catch(() => {
			        this.$message.error("请求错误");
			    })
			    .finally(() => {
			        this.listLoading = false;
			    });
		},
       
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-card__header{
	padding:5px 20px
}
</style>
